import { InjectionToken, Provider } from '@angular/core'

export const closeLabelToken = new InjectionToken<string>('CloseLabelToken')

export const closeLabelProvider: Provider = {
  provide: closeLabelToken,
  useValue: $localize`:Label|Close label:Close`,
}
